module.exports = __webpack_public_path__ + "static/media/picker.7c7a6bbb.svg";